import { render, staticRenderFns } from "./WXLogin.vue?vue&type=template&id=8f1aa510"
import script from "./WXLogin.vue?vue&type=script&lang=js"
export * from "./WXLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports